import React from "react";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./Legal.css";

const LegalLayout = ({ title, subtitle, children }) => (
  <div className="legal-page" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
    <PageBanner title={title} subtitle={subtitle} />
    <ScrollReveal variant="fadeUp">
      <div className="legal-content">{children}</div>
    </ScrollReveal>
  </div>
);

export default LegalLayout;
